import React from "react";
import { Link } from "react-router-dom";
import "../style/style.scss";
import codeImage from "../assets/code.png";
import craftImage from "../assets/craft.png";

const Homepage = () => {
  return (
    <div className="homepage fadeIn">
      <p>Hello</p>
      <p>My name is</p>
      <p className="homepageName">Abby</p>
      <p>I like to make things</p>
      <div className="homepageLinks">
        <a
          href="https://github.com/achristens"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="homepageLink" src={codeImage} alt="Code" />
        </a>
        <Link to="/shop">
          <img className="homepageLink" src={craftImage} alt="Craft" />
        </Link>
      </div>
    </div>
  );
};

export default Homepage;
